import axios from 'axios';
import { logoutUser } from './dataService';

const API_URL = 'https://apienglish.nguyenluan.vn/api/drag-drop';

const handleApiError = (error, defaultMessage) => {
    console.error(`Drag & Drop API Error:`, error.response ? error.response.data : error.message);
    if (error.response && error.response.status === 401) {
        logoutUser();
        throw new Error('Token không hợp lệ hoặc đã hết hạn. Đang đăng xuất...');
    }
    const errorMessage = error.response?.data?.message || error.response?.data?.error || error.message || defaultMessage;
    throw new Error(errorMessage);
};

const getAuthConfig = () => {
    const token = localStorage.getItem('token');
    if (!token) {
        logoutUser();
        throw new Error('Yêu cầu xác thực. Vui lòng đăng nhập lại.');
    }
    return { headers: { Authorization: `Bearer ${token}` } };
};

const createGame = async (topic, difficulty = 'easy', targetScore = 100, pairsPerLevel = 3) => {
    try {
        const config = getAuthConfig();
        const response = await axios.post(`${API_URL}/create`, { 
            topic, 
            difficulty, 
            targetScore, 
            pairsPerLevel 
        }, config);
        return response.data;
    } catch (error) {
        handleApiError(error, 'Không thể tạo trò chơi mới.');
    }
};

const getCurrentLevel = async (gameId) => {
    try {
        const config = getAuthConfig();
        const response = await axios.get(`${API_URL}/${gameId}/level`, config);
        return response.data;
    } catch (error) {
        handleApiError(error, 'Không thể tải dữ liệu màn chơi.');
    }
};

const submitMatch = async (gameId, pairId) => {
    try {
        const config = getAuthConfig();
        const response = await axios.post(`${API_URL}/${gameId}/match`, { pairId }, config);
        return response.data;
    } catch (error) {
        handleApiError(error, 'Không thể gửi kết quả ghép đôi.');
    }
};

const getUserGames = async (status = null, limit = 10, offset = 0) => {
    try {
        const config = getAuthConfig();
        const params = { limit, offset };
        if (status) params.status = status;
        
        const response = await axios.get(`${API_URL}/games`, { ...config, params });
        return response.data;
    } catch (error) {
        handleApiError(error, 'Không thể tải danh sách trò chơi.');
    }
};

const dragDropService = {
    createGame,
    getCurrentLevel,
    submitMatch,
    getUserGames,
};

export default dragDropService;
